import { Component, OnInit, ChangeDetectionStrategy, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable, interval } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Product, ordermodule } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { OrderService } from "../../shared/services/order.service";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'
import { ExternalService } from 'src/app/shared/services/external.service';
import { NgbAlertModule, NgbDatepickerModule, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Items, placeOrder } from 'src/app/shared/classes/order';
import { map } from 'rxjs/operators';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { element } from 'protractor';
import { MyService } from 'src/app/shared/services/myservice';
import { count } from 'console';
import { response } from 'express';


@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CheckoutComponent implements OnInit {
  @ViewChild('Orddetail', { static: true }) Orddetail: ElementRef<any>
  @ViewChild('DeleteModel', { static: true }) DeleteModel: ElementRef<any>
  @ViewChild('AllertPayment', { static: true }) AllertPayment: ElementRef<any>
  @ViewChild('SuccessPay', { static: true }) SuccessPay: ElementRef<any>
  @ViewChild('errorModal', { static: true }) errorModal: ElementRef<any>
  @ViewChild('Termsmodel', { static: true }) Termsmodel: ElementRef<any>

  changeDetection: ChangeDetectionStrategy.OnPush
  timeForm: FormGroup;
  newcustomer: boolean = false
  public checkoutForm: UntypedFormGroup;
  public products: Product[] = [];
  model: NgbDateStruct;
  minDate: NgbDateStruct;
  deliveryDate: NgbDateStruct;
  public ecomproducts: ordermodule[] = [];
  public placeord: placeOrder = {};
  public payment: number = 1;
  onlinePayment = 1;
  codPayment = 2;
  public amount: any;
  public BillAmount: number
  billdetail: any = {
    name: '',
    phone: null,
    postalcode: null,
    town: '',
    address: '',
    state: null,
    iscurrentaddress: false,
    customerid: null
  }
  isTimeValid: boolean;
  constructor(private fb: UntypedFormBuilder,
    public productService: ProductService,
    private orderService: OrderService,
    private _fb: FormBuilder,
    private externalService: ExternalService,
    private calendar: NgbCalendar,
    private modalService: NgbModal,
    private router: Router,
    private toastrService: ToastrService,
    private myService: MyService,
  ) {
    this.newcustomer = false
    this.lenData = []
    this.checkoutForm = this.fb.group({
      name: [null, [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
      // lastname: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
      phone: [null, [Validators.required, Validators.pattern('[0-9]+')]],
      // email: ['', [Validators.required, Validators.email]],
      address: [null, [Validators.required, Validators.maxLength(150)]],
      // country: ['', Validators.required],
      town: [null, Validators.required],
      // state: ['', Validators.required],
      postalcode: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[5-6][0-9]{5}$/) // Ensures it starts with 5 or 6 and has 6 digits
        ]
      ]
    })
    router.events.subscribe((event: NavigationStart) => {
      if (event.navigationTrigger === 'popstate') {
        this.router.navigate(['home/fashion']);
        this.y = localStorage.getItem('myApp_CartCount');
        if (this.y == 0) {
          this.router.navigate(['home/fashion']);
        }
      }
    });

    // Initialize the speechSynthesis instance
    this.speechSynthesis = new SpeechSynthesisUtterance();

    // Load voices after initialization
    this.loadVoices();
  }
  imageurllink: any
  imageurl: any
  filteredProducts: any[] = [];
  taxAmt = 0
  meridian = true;
  converdeliverydate: any
  OrdCui: number = 0
  _secid: string = "";
  x: any = 0;
  y: any = 0;
  status: any = ''
  paymentreqId = ''
  ngOnInit(): void {

    // this.timeboolcheck()
    // this.checktime()
    // const pop = localStorage.getItem("poup")
    // console.log(pop)
    // if (pop === "true") {
    //   this.modalService.open(this.Termsmodel, { centered: true, size: 'lg' });
    // }
    // const urlParams = new URLSearchParams(this.router.url.split('?')[1]);

    const urlParams = new URLSearchParams(this.router.url.split('?')[1]);

    if (urlParams.get('payment_status') === 'Failed') {
      this.modalService.open(this.AllertPayment, { centered: true, size: 'lg' });
    }
    if (urlParams.get('payment_status') === 'Credit') {
      this.status = urlParams.get('payment_status');
      this.paymentreqId = urlParams.get('payment_request_id');

      this.myService.payloadonline.subscribe(xadata => {
        // console.log(xadata)
        this.placeord.status = this.status
        this.placeord.paymentreqId = this.paymentreqId
        this.placeord = xadata
      })
      // console.log(this.status)
      // console.log(this.paymentreqId)
      this.Payloadonline()

      this.modalService.open(this.SuccessPay, { centered: true, size: 'lg' });
      localStorage.setItem("myApp_CartCount", '0');
      // this.modalService.open(this.Orddetail, { centered: true, size: 'lg' });
      this.myService.cartsource.next(0)
    }

    history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", () => {
      this.router.navigate(['/shop/cart']);  // Redirect to cart page
    });

    // history.replaceState(null, '', '/shop/checkout');

    this.checkoutForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      postalcode: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[5-6][0-9]{5}$/) // Ensures it starts with 5 or 6 and has 6 digits
        ]
      ],
      // town: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      address: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(150)]],
      city: [null, Validators.required],
      state: ['', Validators.required],
      landmark: '',
      iscurrentaddress: [false]
    });


    this.getcoupons()
    this.getcustomerAddressIndex()
    this.getliveData()
    this.x = localStorage.getItem('denglu');
    this.y = localStorage.getItem('myApp_CartCount');
    // if (this.y == 0) {
    //   this.router.navigate(['home/fashion']);
    // }
    this.productService.cartItems.subscribe(response => this.ecomproducts = response);
    this.initConfig();
    this._fg = this._fb.group({
      date: [null, [Validators.required]]
    })
    this.billdetail.customerid = localStorage.getItem('customerid');
    this.secid = localStorage.getItem('secid');
    this.OrdCui = parseInt(this.billdetail.customerid, 10) || 0;

    // DATEPICKER--------------------



    const currentDate = new Date();
    let deliveryDate = new Date(); // Start with today
    let deliveryHour = currentDate.getHours();
    let deliveryMinute = currentDate.getMinutes();



    // **Add 2 hours to current time**
    deliveryHour += 2;

    // **Check if delivery time is beyond 9:00 PM (21:00)**
    if (deliveryHour >= 22) {
      deliveryDate.setDate(currentDate.getDate() + 1); // Move to next day
      deliveryHour = 10; // Set to 10:00 AM
      deliveryMinute = 0; // Reset minutes
    }

    // **Set minDate to today's date (or next day if past 9 PM)**
    this.minDate = {
      year: deliveryDate.getFullYear(),
      month: deliveryDate.getMonth() + 1,
      day: deliveryDate.getDate()
    };

    // **Set deliveryDate in date picker**
    this.deliveryDate = {
      year: deliveryDate.getFullYear(),
      month: deliveryDate.getMonth() + 1,
      day: deliveryDate.getDate()
    };
    // console.log(this.deliveryDate)
    // **Set default time in form**
    this.timeForm = this.fb.group({
      selectedTime: [{ hour: deliveryHour, minute: deliveryMinute }]
    });
    // console.log(this.timeForm)
    this.checktime()

  }

  typeCode() {
    // console.log(this.Code)
    const data = this.Coupons.filter(x => x.couponCode == this.Code)
    // console.log(data)
    if (data.length > 0) {
      this.selectedCouponId = data[0].id
      // console.log(this.selectedCouponId)
    } else {
      this.selectedCouponId = 0
    }
  }

  stringifiedData: any
  parsedJson: any = []
  public lenData: any = [];
  public TotalAMount = 0
  public WoTotalAMount = 0

  public SubTotal = 0
  public Livecart: any = [];
  public prodopt = []
  public tax: number = 0
  public BackupCart: any = []

  public ordCount: number = 0

  onlycake: boolean = false
  cartdet: number = 0
  getliveData() {
    this.BillAmount = 0
    this.TotalAMount = 0
    //  document.getElementById('preloaderco').style.display = 'block'
    this.productService.getLiveCart.subscribe(response => {
      // console.log(response)

      if (response["status"] == 200) {

        this.cartdet = response["cartdetId"];
        // console.log(this.cartdet);

        this.Livecart = response["cart"];
        this.BackupCart = response["cart"];
        this.lenData = response['cart']
        const ordcnt = response["count"];
        this.ordCount = ordcnt[0].column1

        // console.log(this.ordCount)
        // console.log(this.Livecart)
        setTimeout(() => {
          document.getElementById('preloaderco').style.display = 'none'
        }, 1300);
        const allowedCategories = this.Livecart
          .filter(item => item.products.CategoryId !== 308) // Exclude CategoryId 308
          .map(item => item.products.CategoryId); // Extract CategoryId

        // console.log(allowedCategories);

        if (allowedCategories.length > 0) { // Check if array is not empty
          // console.log("its work");
          this.onlycake = true
        } else {
          this.onlycake = false

          // console.log("its not work");
        }


        this.Livecart.forEach(data => {
          this.prodopt = data.options
          data.previousQTY = data.Quantity_No
          this.stringifiedData = JSON.stringify(this.prodopt);

          this.parsedJson = JSON.parse(this.stringifiedData);

          const jsonObject: { [key: string]: any } = JSON.parse(this.parsedJson);

          // Convert jsonObject to an array
          const optionsArray = Object.keys(jsonObject).map((key) => jsonObject[key]);
          data.options = optionsArray;
          // console.log(data.options)

          data.options.forEach(ele => {
            data.addons = ele.addons
            data.variants = ele.variants
            data.Msg = ele.msg
          })

          data.addons.forEach(adns => {
            // console.log(adns)
            data.addons.TPrice = 0;
            data.addons.TPrice += adns.price
          });

          data.ProdTotal = ((data.weight.Price + ((data.addons.TPrice || 0) + (data.variants?.price || 0))))
          data.SubTotal = data.ProdTotal * data.Quantity_No
          data.withoutDisc = data.ProdTotal * data.Quantity_No
          this.WoTotalAMount += data.ProdTotal * data.Quantity_No
          this.TotalAMount += data.SubTotal
          // console.log(this.TotalAMount)
          // console.log(data.products.tax)
          this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
          this.tax = data.products.tax
          // console.log(this.taxAmt)
          const Amt = this.TotalAMount
          // console.log(Amt)
          this.BillAmount = Math.ceil(Amt);
        })

      } else {
        this.router.navigate(['home/fashion']);
      }
      // console.log(this.lenData)
    });

  }

  setBillAmount() {
    this.TotalAMount = 0
    this.tax = 0
    this.BillAmount = 0
    this.Livecart.forEach(data => {
      data.CouponAmt = 0
      data.coupontotal = 0
      data.coupTypeid = 0
      data.coupvalue = 0
      data.Coupon = null
      data.options.forEach(ele => {
        data.addons = ele.addons
        data.variants = ele.variants
        data.Msg = ele.msg
      })
      data.addons.forEach(adns => {
        // console.log(adns)
        data.addons.TPrice = 0;
        data.addons.TPrice += adns.price
      });
      data.ProdTotal = ((data.weight.Price + ((data.addons.TPrice || 0) + (data.variants?.price || 0))))
      data.SubTotal = data.ProdTotal * data.Quantity_No
      this.TotalAMount += data.SubTotal
      this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
      this.tax = data.products.tax
      const Amt = this.TotalAMount
      this.BillAmount = Math.ceil(Amt);
    })
  }
  isTimeDisabled(time: any): boolean {
    const selectedHour = time.hour;
    return selectedHour < 10 || selectedHour > 22;
  }
  deliveryDates: string
  currentTime = { hour: new Date().getHours(), minute: new Date().getMinutes() };
  OldonDeliveryDateChange(date: NgbDateStruct) {
    if (date) {
      this.deliveryDates = `${date.year}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;
      const nextDate = new Date(date.year, date.month - 1, date.day + 2);
      const nextTime = { hour: 10, minute: 0 };
      this.timeForm.patchValue({ selectedTime: nextTime });
    }
  }

  chrs = 0
  dbool = false
  onDeliveryDateChange(date: NgbDateStruct) {
    if (date) {
      const selectedDate = new Date(date.year, date.month - 1, date.day);
      // console.log("sd: ", selectedDate);
      // console.log("sd: 2", date.day);
      var cday = date.day;
      const now = new Date();
      // console.log(now);
      var day = '' + now.getDate()
      var hrs = '' + now.getHours()
      // console.log("day: ", day);
      // console.log("day: ", hrs);
      if (Number(day) == cday) {
        this.dbool = false;
      }
      else {
        this.dbool = true;
      }
      if (selectedDate >= now) {
        this.timeForm.patchValue({ selectedTime: { hour: 10, minute: 0 } });
      } else {
        const now = new Date();
        now.setHours(now.getHours() + 2);
        this.timeForm.patchValue({ selectedTime: { hour: now.getHours(), minute: now.getMinutes() } });
      }
    }
  }
  getCurrentTime(): Observable<Date> {
    return interval(1000).pipe(
      map(() => new Date())
    );
  }
  showdelivery: boolean = true
  public get getTotal(): Observable<number> {
    return this.productService.cartTotalAmount();
  }
  // Stripe Payment Gateway
  stripeCheckout() {
    var handler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_token, // publishble key
      locale: 'auto',
      token: (token: any) => {
        this.orderService.createOrder(this.products, this.checkoutForm.value, token.id, this.amount);
      }
    });
    handler.open({
      name: 'Multikart',
      description: 'Online Fashion Store',
      amount: this.amount * 100
    })
  }
  // Paypal Payment Gateway
  private initConfig(): void {
    // this.payPalConfig = {
    //     currency: this.productService.Currency.currency,
    //     clientId: environment.paypal_token,
    //     createOrderOnClient: (data) => < ICreateOrderRequest > {
    //       intent: 'CAPTURE',
    //       purchase_units: [{
    //           amount: {
    //             currency_code: this.productService.Currency.currency,
    //             value: this.amount,
    //             breakdown: {
    //                 item_total: {
    //                     currency_code: this.productService.Currency.currency,
    //                     value: this.amount
    //                 }
    //             }
    //           }
    //       }]
    //   },
    //     advanced: {
    //         commit: 'true'
    //     },
    //     style: {
    //         label: 'paypal',
    //         size:  'small', // small | medium | large | responsive
    //         shape: 'rect', // pill | rect
    //     },
    //     onApprove: (data, actions) => {
    //         this.orderService.createOrder(this.products, this.checkoutForm.value, data.orderID, this.getTotal);
    //         console.log('onApprove - transaction was approved, but not authorized', data, actions);
    //         actions.order.get().then(details => {
    //             console.log('onApprove - you can get full order details inside onApprove: ', details);
    //         });
    //     },
    //     onClientAuthorization: (data) => {
    //         console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
    //     },
    //     onCancel: (data, actions) => {
    //         console.log('OnCancel', data, actions);
    //     },
    //     onError: err => {
    //         console.log('OnError', err);
    //     },
    //     onClick: (data, actions) => {
    //         console.log('onClick', data, actions);
    //     }
    // };
  }

  customerid: Number = 0
  cusAddress: any[] = []

  savebill: any = {
    customerid: null
  }

  filteredAddresses = []
  custmrid: string = ''
  secid: string = ''
  getcustomerAddressIndex() {
    // this.externalService.GetCustAddress(this.billdetail.customerid)
    this.custmrid = localStorage.getItem('customerid')
    this.secid = localStorage.getItem('secid')
    this.externalService.GetCustAddress(this.custmrid, this.secid).subscribe(response => {
      // console.log(response)
      // setTimeout(() => {
      //   document.getElementById('preloaderco').style.display = 'none'
      // }, 1300);
      this.cusAddress = response
      // console.log(this.cusAddress);
      if (this.cusAddress.length == 0) {
        this.hidevalue = 1
        this.cartvalue = 1
        this.newcustomer = true
      }
      if (this.cusAddress.length == 1) {
        this.checkvalue = 1
        this.hidevalue = 2
        this.cartvalue = 1
        this.newcustomer = false
      }
      if (this.cusAddress.length > 1) {
        this.checkvalue = 2
        this.hidevalue = 2
        this.cartvalue = 1
        this.newcustomer = false
        this.getcustomerAddressIndexAll()
      }

      this.filteredAddresses = this.cusAddress.filter(address => address.iscurrentaddress);
      this.CusAddId = this.filteredAddresses[0]?.id
      document.getElementById('preloaderco').style.display = 'none'
    })
  }
  checkvalue: number = 0
  hidevalue: number = 0
  cartvalue: number = 0
  CusAddId: number = 0
  NewCustomer(id) {
    this.billdetail = {
      name: '',
      phone: null,
      postalcode: null,
      town: '',
      address: '',
      state: null,
      iscurrentaddress: false,
      customerid: null
    }
    if (id == 2) {
      this.hidevalue = 1
      this.checkvalue = id
      this.newcustomer = true;
    } else {
      this.checkvalue = id
      this.getcustomerAddressIndexAll()
      this.newcustomer = false;
      this.hidevalue = 2
      this.checkoutForm.markAsDirty()
    }
  }

  getcustomerAddressIndexAll() {
    // this.externalService.GetCustAddress(this.billdetail.customerid).subscribe(response => {
    if (this.DelCusADDId == 0) {
      this.filteredAddresses = this.cusAddress
    } else {
      this.filteredAddresses = this.cusAddress.filter(x => x.id != this.DelCusADDId)
    }
  }


  selectedOption: string = 'option1';
  submitted: boolean = false
  showAddress: boolean = false
  changefilter(bool) {
    this.billdetail.iscurrentaddress = bool
    // console.log(bool)
  }

  SaveAddresssss() {
    this.showAddress = true
    this.savebill.name = this.billdetail.name;
    this.savebill.phoneno = this.billdetail.phone;
    this.savebill.iscurrentaddress = this.billdetail.iscurrentaddress
    this.savebill.customerid = this.billdetail.customerid
    // console.log(this.savebill.customerid);
    this.savebill.address = `${this.billdetail.address}, ${this.billdetail.town} -
     ${this.billdetail.postalcode}, ${this.billdetail.state} | ${this.billdetail.phone}`;
    // console.log(this.savebill, 'sbill');
    // console.log(this.billdetail, 'billdetail');
    this.billdetail = {
      name: null,
      phone: null,
      postalcode: null,
      town: null,
      address: null,
      state: null,
      iscurrentaddress: false,
      customerid: null
    }

    this.externalService.SaveCustAddress.subscribe(response => {
      this.newcustomer = false
      this.getcustomerAddressIndex()
    })
    this.submitted = false
  }

  // SaveAddress() {
  //   if (this.checkoutForm.valid) {
  //     document.getElementById('preloaderco').style.display = 'block';

  //     if (this.cusAddress.length == 0) {

  //     }

  //     this.savebill = {
  //       name: this.checkoutForm.controls['name'].value,
  //       phoneno: this.checkoutForm.controls['phone'].value,
  //       iscurrentaddress: this.checkoutForm.controls['iscurrentaddress'].value,
  //       address: this.checkoutForm.controls['address'].value,
  //       city: this.checkoutForm.controls['town'].value,
  //       pincode: this.checkoutForm.controls['postalcode'].value,
  //       landmark: this.checkoutForm.controls['state'].value,
  //       customerid: localStorage.getItem('customerid'),
  //     };
  //     if (this.cusAddress.length == 0) {
  //       this.savebill.iscurrentaddress = true
  //     }

  //     this.externalService.SaveCustomerAddress(this.savebill).subscribe(
  //       (response) => {
  //         // console.log(response);
  //         this.submitted = false;
  //         this.getcustomerAddressIndex();
  //         this.checkoutForm.reset();
  //         this.newcustomer = false;
  //         this.toastrService.success('Address Saved successful', 'Success');

  //       },
  //       (error) => {
  //         // console.error('Error saving address:', error);
  //         this.toastrService.error('Address Saved Unsuccessful', 'Error');

  //       }
  //     );
  //   } else {
  //     Object.keys(this.checkoutForm.controls).forEach((field) => {
  //       const control = this.checkoutForm.get(field);
  //       control?.markAsTouched({ onlySelf: true });
  //     });
  //   }
  // }

  SaveAddress() {
    // console.log(this.savebill)
    // console.log(this.maduraiCityError, this.maduraiDeliveryError)
    if (this.checkoutForm.valid) {

      if (this.maduraiCityError == false && this.maduraiDeliveryError == false) {
        document.getElementById('preloaderco').style.display = 'block';
        this.savebill = {
          name: this.checkoutForm.controls['name'].value,
          phoneno: this.checkoutForm.controls['phone'].value,
          iscurrentaddress: this.checkoutForm.controls['iscurrentaddress'].value,
          address: this.checkoutForm.controls['address'].value,
          city: this.checkoutForm.controls['city'].value,
          pincode: this.checkoutForm.controls['postalcode'].value,
          landmark: this.checkoutForm.controls['landmark'].value,
          state: this.checkoutForm.controls['state'].value,
          customerid: localStorage.getItem('customerid'),
        };
        if (this.cusAddress.length == 0) {
          this.savebill.iscurrentaddress = true
        }

        this.externalService.SaveCustomerAddress(this.savebill).subscribe(
          (response) => {
            // console.log(response);
            this.submitted = false;
            this.getcustomerAddressIndex();
            this.checkoutForm.reset();
            this.newcustomer = false;
            this.toastrService.success('Address Saved successful', 'Success');

          },
          (error) => {
            // console.error('Error saving address:', error);
            this.toastrService.error('Address Saved Unsuccessful', 'Error');

          }
        );
      } else {
        this.openErrorModal();
      }
    } else {
      Object.keys(this.checkoutForm.controls).forEach((field) => {
        const control = this.checkoutForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }


  validateNumericInput(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const inputChar = event.key;
    if (!allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }
  }

  validateAlphabeticInput(event: KeyboardEvent) {
    const keyCode = event.keyCode;
    const allowedKeyCodes = [8, 9, 32];
    if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || allowedKeyCodes.includes(keyCode))) {
      event.preventDefault();
    }
  }

  _fg: FormGroup;


  submit() {
    // console.log(this._fg.value)
  }


  DeleteAddress() {
    document.getElementById('preloaderco').style.display = 'block'
    this.modalService.dismissAll();
    this.externalService.DeleteCustomer(this.DelCusId, this.DelCusADDId)
    this.externalService._getcusDel.subscribe(response => {
      document.getElementById('preloaderco').style.display = 'none'
      // console.log(response)
      // this.getcustomerAddressIndex()
      this.filteredAddresses = this.cusAddress.filter(x => x.id != this.DelCusADDId)
      // console.log(this.filteredAddresses)
      this.toastrService.warning('Address Deleted!', '')

    })
  }

  DelCusADDId: number = 0
  DelCusId: number = 0

  remove(item) {
    // console.log(item)
    // console.log(item.id)
    this.DelCusADDId = item.id
    this.DelCusId = item.customerId

    this.modalService.open(this.DeleteModel, { centered: true, size: 'l' });

  }


  custaddresid: any
  customerId: any

  selectCustomerAddress(customerId, custadresid) {
    // this.billdetail = {}
    this.customerId = customerId
    // console.log('hii', this.customerId);
    document.getElementById('preloaderco').style.display = 'block'
    this.custaddresid = custadresid
    // console.log('customerAddressId', this.custaddresid);

    this.externalService.SelectCustomerAddress(this.customerId, this.custaddresid).subscribe(response => {
      // console.log('SelectCustAddress', response);

      localStorage.setItem('customeraddressid', this.custaddresid?.toString());
      this.getcustomerAddressIndex()
      this.checkoutForm.reset()

      // this.timer = true
      this.newcustomer = false
      // console.log(this.newcustomer)
    })
    // console.log(this.newcustomer)
  }





  time_bool: boolean = false;
  timeboolcheck() {
    if (this.dbool == true) {
      if (this.timeForm.value.selectedTime.hour >= 10 && this.timeForm.value.selectedTime.minute >= 0 && this.timeForm.value.selectedTime.hour <= 20 && this.timeForm.value.selectedTime.minute <= 60) {
        this.time_bool = true;
      }
      else {
        this.time_bool = false;
      }

    }
    else {
      if (this.timeForm.value.selectedTime.hour >= this.chrs && this.timeForm.value.selectedTime.hour <= 20) {
        this.time_bool = true;
      }
      else {
        this.time_bool = false;
      }
    }
    // console.log("this.time_bool: ", this.time_bool)
    return this.time_bool;
  }


  increment(product, qty = 1) {
    // console.log(product)
    if (product.Quantity_No < 10) {
      this.productService.updateCartQuantity(product, qty);
      product.Quantity_No++;
    }
    this.changeprice()
  }


  // Decrement
  decrement(product, qty = -1) {
    // console.log(product)
    if (product.Quantity_No > 1) product.Quantity_No--;
    this.productService.updateCartQuantity(product, qty);
    this.changeprice()
  }


  changeprice() {

    this.BillAmount = 0;
    this.taxAmt = 0;
    this.tax = 0;
    this.WoTotalAMount = 0;
    this.TotalAMount = 0;
    // console.log(this.Livecart);

    this.Livecart.forEach(data => {
      this.prodopt = data.options;
      this.stringifiedData = JSON.stringify(this.prodopt);
      this.parsedJson = JSON.parse(this.stringifiedData);

      data.options.forEach(ele => {
        data.addons = ele.addons;
        data.variants = ele.variants;
        data.Msg = ele.msg;
      });

      data.addons.forEach(adns => {
        data.addons.TPrice = 0;
        data.addons.TPrice += adns.price;
      });

      data.ProdTotal = ((data.weight.Price + ((data.addons.TPrice || 0) + (data.variants?.price || 0))));
      data.SubTotal = data.ProdTotal * data.Quantity_No;
      data.withoutDisc = data.ProdTotal * data.Quantity_No;
      this.WoTotalAMount += data.ProdTotal * data.Quantity_No;
      this.TotalAMount += data.SubTotal;

      this.taxAmt = ((this.TotalAMount * data.products.tax) / 100);
      this.tax = data.products.tax;
      // const Amt = ((this.TotalAMount * data.products.tax) / 100) + this.TotalAMount;
      const Amt = this.TotalAMount;

      this.BillAmount = Math.ceil(Amt);
      // console.log(this.BillAmount);
    });
  }


  validateQuantity(product) {
    // Ensure value is between 1 and 10
    if (product.Quantity_No > 10) {
      product.Quantity_No = 10;
    } else if (product.Quantity_No < 1 || !product.Quantity_No) {
      product.Quantity_No = 1;
    }
  }



  public placeOrderNow(): void {

    this.timeboolcheck();

    if (this.CusAddId == null || this.CusAddId == undefined) {
      // return alert("Please Add or Select your Delivery Address");
      this.toastrService.error('Please Add or Select your Delivery Address');
    }

    if (this.time_bool == false) {
      // return alert("Please Change Invalid Delivery Date and Time!");
      this.toastrService.error('Please Change Invalid Delivery Date and Time!');


    }
    else {
      // if (this.payment == 1) {
      //   return alert("Temporary Online Service Stopped!");
      // }
      if (this.filteredAddresses.length == 0) {
        // this.toastrService.error('Please fill all required fields', 'Error');
        // return;
      }
      else {
        this.placeord = {}
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        const time = `${hours}:${minutes}:${seconds}`;

        const formattedDate = `${this.deliveryDate.year}-${String(this.deliveryDate.month).padStart(2, '0')}-${String(this.deliveryDate.day).padStart(2, '0')}`;

        const timeString = `${this.timeForm.value.selectedTime.hour.toString().padStart(2, '0')}:${this.timeForm.value.selectedTime.minute.toString().padStart(2, '0')}:00`;


        this.placeord.ta = parseFloat(this.BillAmount.toFixed(2))
        this.placeord.subtotal = this.TotalAMount
        this.placeord.totalItemvalue = this.WoTotalAMount
        this.placeord.tamt = ((this.TotalAMount * this.tax) / 100)
        this.placeord.cui = this.OrdCui
        this.placeord.secid = this.secid;
        this.placeord.cuai = this.CusAddId
        this.placeord.PaymentTypeId = this.payment
        this.placeord.ddT = formattedDate + 'T' + timeString
        this.placeord.N = this.note
        this.placeord.ci = 12
        this.placeord.ino = 'FB-INO'







        // let opt:any=[];
        // this.Livecart.forEach(element=>
        //   {
        //     console.log("element",element)
        //     opt.push([
        //       {
        //       id: element.addons[0]?.id,
        //       name: element.addons[0]?.qtyText,
        //       price: element.addons[0]?.price,
        //       productId: element.addons[0]?.ProductId,
        //       typeId: element.addons[0]?.typeId,
        //       actProdId: element.addons[0]?.actProdId
        //     }
        //   ]) 
        //   this.placeord.items = opt
        //   })


        // this.placeord.items=opt;

        let Items: any = [];
        // console.log(this.Livecart)
        this.Livecart.forEach(element => {
          // Items.push({
          //   product: {
          //     id: element.products.Id,
          //     name: element.products.Name,
          //     quantity: element.Quantity_No,
          //     message: element.Msg,
          //     img: element.products.ImgUrl,

          //     wg_id: element.weight.Id,
          //     wg_qty: element.weight.Qty,
          //     wg_price: element.weight.Price,
          //     wg_qtytxt: element.weight.QtyText,

          //     v_id: element.variants?.id,
          //     v_name: element.variants?.qtyText,
          //     v_price: element.variants?.price,
          //     v_typeId: element.variants?.typeId,
          //     v_actProdId: element.variants?.actProdId

          //   },
          //   weight: {
          //     id: element.weight.Id,
          //     qty: element.weight.Qty,
          //     price: element.weight.Price,
          //     productId: element.ProductId,
          //     typeId: element.weight.TypeId,
          //     qtyText: element.weight.QtyText
          //   },

          //   options: {
          //     addons: [{
          //       id: element.addons[0]?.id,
          //       name: element.addons[0]?.qtyText,
          //       price: element.addons[0]?.price,
          //       productId: element.addons[0]?.ProductId,
          //       typeId: element.addons[0]?.typeId,
          //       actProdId: element.addons[0]?.actProdId
          //     }],



          //     variants: {
          //       id: element.variants?.id,
          //       name: element.variants?.qtyText,
          //       price: element.variants?.price,
          //       productId: element.variants?.ProductId,
          //       typeId: element.variants?.typeId,
          //       actProdId: element.variants?.actProdId
          //     }
          //   }


          // console.log("ele:::",element)
          Items.push({
            product: {
              id: element.products.Id,
              name: element.products.Name,
              quantity: element.Quantity_No,
              message: element.Msg,
              img: element.products.ImgUrl,
              prodtotal: element.ProdTotal,
              catId: element.products.CategoryId,
              wg_id: element.weight.Id,
              wg_qty: element.weight.Qty,
              wg_price: element.weight.Price,
              wg_qtytxt: element.weight.QtyText,

              // this.placeord.tamt = ((this.TotalAMount * this.tax) / 100)

              taxAmt: ((element.ProdTotal * this.tax) / 100),
              to: ((element.ProdTotal * this.tax) / 100) / 2,
              tt: ((element.ProdTotal * this.tax) / 100) / 2,
              v_id: element.variants?.id ? element.variants?.id : null,
              v_name: element.variants?.qtyText ? element.variants?.qtyText : null,
              v_price: element.variants?.price ? element.variants?.price : null,
              v_typeId: element.variants?.typeId ? element.variants?.typeId : null,
              v_actProdId: element.variants?.actProdId ? element.variants?.actProdId : null,
              addons: [{
                id: element.addons[0]?.id,
                name: element.addons[0]?.qtyText,
                price: element.addons[0]?.price,
                productId: element.addons[0]?.ProductId,
                typeId: element.addons[0]?.typeId,
                actProdId: element.addons[0]?.actProdId
              }],
              coupons: element.Coupon || null
            }

          });



          this.placeord.items = Items;
          // console.log(this.successcoupon)
          if (this.successcoupon.couponid > 0) {
            this.placeord.coupenid = this.successcoupon.couponid
            this.placeord.coupenstatus = true

            // this.placeord.items.forEach(ite => {
            //   ite.coupenid = this.successcoupon.couponid
            //   ite.coupenstatus = true
            //   ite.RefAmount = this.CouponAmount
            // })
          } else {
            this.placeord.coupenid = 0
            this.placeord.coupenstatus = false

            // this.placeord.items.forEach(ite => {
            //   ite.coupenid = 0
            //   ite.coupenstatus = false
            //   ite.RefAmount = 0
            // })
          }

          // console.log(this.successref)
          if (this.successref.refid > 0) {
            this.placeord.RefId = this.successref.refid
            this.placeord.Refstatus = true
            this.placeord.RefType = this.successref.reftype

            // this.placeord.items.forEach(ite => {
            //   ite.RefId = this.successref.refid
            //   ite.Refstatus = true
            //   ite.RefAmount = this.ReferralAmount
            // })
          } else {
            this.placeord.RefId = 0
            this.placeord.Refstatus = false
            this.placeord.RefType = 0

            // this.placeord.items.forEach(ite => {
            //   ite.RefId = 0
            //   ite.Refstatus = false
            //   ite.RefAmount = 0
            // })
          }

        })

        // console.log("PLace Orders::::", this.placeord);
        this.modalService.dismissAll()
        document.getElementById('preloaderco').style.display = 'block'
        this.productService.SaveOrder(this.placeord).subscribe(response => {
          if (response && response['status'] == 200) {
            // localStorage.setItem('poup', 'false')
            this.OrdId = response.oid
            // console.log(this.OrdId)
            localStorage.setItem("myApp_CartCount", '0');
            this.myService.cartsource.next(0)
            document.getElementById('preloaderco').style.display = 'none'
            this.modalService.open(this.Orddetail, { centered: true, size: 'lg' });
          } else {
            // localStorage.setItem('poup', 'false')
            this.toastrService.error('Order', 'Order Placed UnSuccessfully !..')
          }
        });
      }
    }
  }


  public placeOrderNowbyOnline(): void {

    this.timeboolcheck();

    if (this.CusAddId == null || this.CusAddId == undefined) {
      // return alert("Please Add or Select your Delivery Address");
      this.toastrService.error('Please Add or Select your Delivery Address');
    }

    if (this.time_bool == false) {
      // return alert("Please Change Invalid Delivery Date and Time!");
      this.toastrService.error('Please Change Invalid Delivery Date and Time!');

    }
    else {
      if (this.filteredAddresses.length == 0) {
        // this.toastrService.error('Please fill all required fields', 'Error');
        // return;
      }
      else {
        this.placeord = {}
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        const time = `${hours}:${minutes}:${seconds}`;

        const formattedDate = `${this.deliveryDate.year}-${String(this.deliveryDate.month).padStart(2, '0')}-${String(this.deliveryDate.day).padStart(2, '0')}`;

        const timeString = `${this.timeForm.value.selectedTime.hour.toString().padStart(2, '0')}:${this.timeForm.value.selectedTime.minute.toString().padStart(2, '0')}:00`;


        // this.placeord.ta = parseFloat(this.BillAmount.toFixed(2))
        this.placeord.ta = parseFloat(this.BillAmount.toFixed(2))
        this.placeord.subtotal = this.TotalAMount
        this.placeord.totalItemvalue = this.WoTotalAMount
        this.placeord.tamt = ((this.TotalAMount * this.tax) / 100)
        this.placeord.cui = this.OrdCui
        this.placeord.secid = this.secid;
        this.placeord.cuai = this.CusAddId
        this.placeord.PaymentTypeId = this.payment
        this.placeord.ddT = formattedDate + 'T' + timeString
        this.placeord.N = this.note
        this.placeord.ci = 12
        this.placeord.ino = 'FB-INO'

        let Items: any = [];
        this.Livecart.forEach(element => {
          // console.log("ele:::",element)
          Items.push({
            product: {
              id: element.products.Id,
              name: element.products.Name,
              quantity: element.Quantity_No,
              message: element.Msg,
              img: element.products.ImgUrl,
              prodtotal: element.ProdTotal,
              catId: element.products.CategoryId,
              wg_id: element.weight.Id,
              wg_qty: element.weight.Qty,
              wg_price: element.weight.Price,
              wg_qtytxt: element.weight.QtyText,

              taxAmt: ((element.ProdTotal * this.tax) / 100),
              to: ((element.ProdTotal * this.tax) / 100) / 2,
              tt: ((element.ProdTotal * this.tax) / 100) / 2,

              v_id: element.variants?.id ? element.variants?.id : null,
              v_name: element.variants?.qtyText ? element.variants?.qtyText : null,
              v_price: element.variants?.price ? element.variants?.price : null,
              v_typeId: element.variants?.typeId ? element.variants?.typeId : null,
              v_actProdId: element.variants?.actProdId ? element.variants?.actProdId : null,
              addons: [{
                id: element.addons[0]?.id,
                name: element.addons[0]?.qtyText,
                price: element.addons[0]?.price,
                productId: element.addons[0]?.ProductId,
                typeId: element.addons[0]?.typeId,
                actProdId: element.addons[0]?.actProdId
              }],
              coupons: element.Coupon || null
            }
          });
          this.placeord.items = Items;

          // console.log(this.successcoupon)
          if (this.successcoupon.couponid > 0) {
            this.placeord.coupenid = this.successcoupon.couponid
            this.placeord.coupenstatus = true

            // this.placeord.items.forEach(ite => {
            //   ite.coupenid = this.successcoupon.couponid
            //   ite.coupenstatus = true
            //   ite.RefAmount = this.CouponAmount
            // })
          } else {
            this.placeord.coupenid = 0
            this.placeord.coupenstatus = false
            // this.placeord.items.forEach(ite => {
            //   ite.coupenid = 0
            //   ite.coupenstatus = false
            //   ite.RefAmount = 0
            // })
          }

          // console.log(this.successref)
          if (this.successref.refid > 0) {
            this.placeord.RefId = this.successref.refid
            this.placeord.Refstatus = true
            this.placeord.RefType = this.successref.reftype

            this.placeord.items.forEach(ite => {
              ite.RefId = this.successref.refid
              ite.Refstatus = true
              ite.RefAmount = this.ReferralAmount
            })
          } else {
            this.placeord.RefId = 0
            this.placeord.Refstatus = false
            this.placeord.RefType = 0

            this.placeord.items.forEach(ite => {
              ite.RefId = 0
              ite.Refstatus = false
              ite.RefAmount = 0
            })
          }

        })
        this.myService.payloadonline.next(this.placeord)
        // console.log("PLace Orders::::", this.placeord);

        const savedata = {
          cui: this.placeord.cui,
          secid: this.placeord.secid,
          ta: this.placeord.ta
        }

        const payload = {
          id: this.cartdet || 0,
          cusId: this.OrdCui,
          cusAdid: this.CusAddId,
          toAmt: parseFloat(this.BillAmount.toFixed(2)),
          taxAmt: ((this.TotalAMount * this.tax) / 100),
          didt: formattedDate + 'T' + timeString,
          Note: this.note,
          Cid: this.placeord.coupenid,
          Rid: this.placeord.RefId,
        };

        // console.log(payload)
        this.orderService.saveorderpay(payload).subscribe(response => {
          // console.log(response);

          if (response.status == 200) {
            console.log("payload send successfully")
          }
          else {
            console.log("payload send unsuccessfull")
          }
        })

        this.modalService.open(this.Orddetail, { centered: true, size: 'lg' });
        this.modalService.dismissAll()
        document.getElementById('preloaderco').style.display = 'block'
        this.productService.SaveOrderonline(savedata).subscribe(response => {
          // console.log(response)
          if (response.status == "success") {
            // localStorage.setItem('poup', 'false')
            // this.toastrService.success('Order Placed Succesfully', 'Success');
            document.getElementById('preloaderco').style.display = 'none'
            // this.modalService.open(this.Orddetail, { centered: true, size: 'lg' });
            window.open(response.root, "_self")
          } else {
            // localStorage.setItem('poup', 'false')
            this.modalService.open(this.AllertPayment, { centered: true, size: 'l' });
            // console.log("Your Order Saved, Onlinepayment Failed, please Make COD")
          }
        });
      }
    }
  }

  closePaymenterror() {
    history.replaceState(null, '', '/shop/checkout');
    // this.router.navigateByUrl('/shop/order/management')
    this.modalService.dismissAll();
  }

  onTimeChange(newTime: any) {
    // console.log('Selected time:', newTime);
    // Perform any additional actions with the new time value
  }

  OrdId: Number = 0



  // selectedTime: { hour: number, minute: number } = { hour: 12, minute: 0 }

  // time = { hour: 13, minute: 30 };

  SelectDate() {
    // console.log('DeliveryDate', this.deliveryDate);
  }



  // SelectDeliveryTime() {
  //   console.log('selectedTime',this.selectedTime);

  // }


  paymenttype(value) {
    this.onlinePayment = value
    // console.log('onlinePayment', this.onlinePayment);


    this.payment = this.onlinePayment
    // console.log('payment', this.payment);

  }



  paymenttype2(value) {
    this.codPayment = value
    // console.log('codPayment', this.codPayment);

    this.payment = this.codPayment
    // console.log('payment', this.payment);

  }


  note: string = ''


  public modalOpen: boolean = false;
  openModal() {
    this.modalOpen = true;
    this.modalService.open(this.Orddetail, {
      size: 'lg',
      ariaLabelledBy: 'Cart-Modal',
      centered: true,
      windowClass: 'theme-modal cart-modal CartModal'
    })

  }

  // back() {
  //   this.modalService.dismissAll();
  //   this.router.navigateByUrl('home/fashion')
  // }


  continueshop() {
    this.modalService.dismissAll();
    // this.router.navigateByUrl('/shop/collection/left/sidebar?category:118');
  }

  Trackord() {
    this.router.navigateByUrl('/shop/order/management')
    this.modalService.dismissAll();
  }


  invalidTime: boolean = false;

  checktime() {
    // console.log(this.timeForm)
    let selectedHour: number = this.timeForm.value.selectedTime.hour;
    let selectedMinute: number = this.timeForm.value.selectedTime.minute;

    const currentDate = new Date();
    const selectedDate = new Date(this.deliveryDate.year, this.deliveryDate.month - 1, this.deliveryDate.day);
    let minDeliveryTime = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000); // Add 2 hours
    // console.log(minDeliveryTime)

    let minHour = minDeliveryTime.getHours();
    let minMinute = minDeliveryTime.getMinutes();

    // console.log(minHour,selectedHour)

    // console.log(minMinute,selectedMinute)
    // Reset the error flag
    this.invalidTime = false;

    // Apply "2 hours later" restriction only for the current date
    if (
      selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getDate() === currentDate.getDate()
    ) {
      if (selectedHour < minHour || (selectedHour === minHour && selectedMinute < minMinute)) {
        this.timeForm.patchValue({ selectedTime: { hour: minHour, minute: minMinute } });
        // console.log(this.timeForm.patchValue({ selectedTime: { hour: minHour, minute: minMinute } }))
        this.invalidTime = true; // Mark as invalid
        return; // Exit early after correcting time
      }
    }

    // Enforce the valid delivery time range (10 AM - 10 PM)
    if (selectedHour < 10) {
      this.timeForm.patchValue({ selectedTime: { hour: 10, minute: 0 } });
      this.invalidTime = false;
    } else if (selectedHour >= 22) {
      this.timeForm.patchValue({ selectedTime: { hour: 21, minute: 59 } }); // Set max to 9:59 PM
      this.invalidTime = false;
    }
  }









  Coupons: any = []
  getcoupons() {
    const cusid = localStorage.getItem('customerid');
    const custId = parseInt(cusid, 10) || 0;
    this.externalService.getCouponsCheckout(custId).subscribe(coup => {
      this.Coupons = coup["allcpn"] || [];
      this.Coupons = this.Coupons.map(element => element.childCoupons[0] || element);

      const now = new Date(); // Declare 'now' before using it

      this.Coupons = this.Coupons.filter(c => c.isUsed == false && new Date(c.validUpTo) >= now);

      // console.log(this.Coupons);
      // console.log(now);

      this.Coupons.forEach(coupon => {
        const validDate = new Date(coupon.validUpTo);
        coupon.expired = validDate < now;
      });

      // console.log(this.Coupons);
    });
  }

  Code: string = ''
  selectedCouponId: any
  selectedCoupon: any = null
  hideBtn: boolean = false
  selectCode(value) {
    // console.log(value)
    // this.hideBtn = true
    this.selectedCoupon = value
    this.selectedCoupon.status = true
    this.Code = this.selectedCoupon.couponCode
  }


  HideCoupon: boolean = false
  filterProduct: any = []
  CouponAmount: number = 0

  checkCoupon: boolean = false
  checkProductarray: any = []

  successcoupon: any = []
  finalcoup: any = []
  loadingcoup: boolean = false
  applyCoupon() {

    if (this.Code != '') {
      this.loadingcoup = true; // Show loading
    }
    this.checkCoupon = false
    this.filterProduct = []
    this.successcoupon = []
    this.finalcoup = []
    this.checkProductarray = {
      products: []
    };
    if (this.Code != '') {
      this.selectedCoupon = this.Coupons.filter(coup => coup.couponCode == this.Code)[0]
      // console.log(this.selectedCoupon)
      // console.log(this.Livecart)
      if (this.selectedCoupon == null) {
        this.checkCoupon = true
        this.loadingcoup = false
      } else {
        this.selectedCoupon.status = true
        if (this.Code == this.selectedCoupon.couponCode) {

          // let couparraydata = this.selectedCoupon.cop_prod
          // couparraydata.forEach(element => {
          //   let equaldatacheck = this.Livecart.filter(item => (item.products.CategoryId === element.offCatId) || (item.products.Id === element.offProdId));

          //   console.log(equaldatacheck)
          // });
          const cusid = localStorage.getItem('customerid');
          const custId = parseInt(cusid, 10) || 0;
          this.Livecart.forEach(element => {
            const data = {
              prodid: element.products.Id,
              catid: element.products.CategoryId,
            };
            // console.log(data)
            // Push each product data object into the products array
            this.checkProductarray.products.push(data);
          })
          this.checkProductarray.coupenid = this.selectedCoupon.id,
            this.checkProductarray.coupencode = this.selectedCoupon.couponCode,
            this.checkProductarray.secid = this.secid,


            this.checkProductarray.custid = custId
          // console.log(this.checkProductarray)

          this.externalService.GetCouponscheck(this.checkProductarray)
          this.externalService._GetCouponscheck.subscribe(response => {
            // console.log(response)
            if (response) {
              this.TotalAMount = 0
              this.CouponAmount = 0
              this.tax = 0
              this.BillAmount = 0
              // console.log(this.selectedCoupon)
              // console.log(this.Livecart)

              let couparraydata1 = this.selectedCoupon.cop_prod
              // console.log(couparraydata1)
              // couparraydata1.forEach(element => {
              let equaldata = this.Livecart.filter(item => (item.products.CategoryId == couparraydata1.offCatId) || (item.products.Id == couparraydata1.offProdId));
              // console.log(equaldata)
              if (equaldata.length > 0) {
                this.filterProduct = equaldata
              }
              // console.log(this.filterProduct)
              // });
              // console.log(couparraydata1)
              this.Livecart.forEach(element => {
                let finalcoup = couparraydata1.offCatId == element.products.CategoryId || couparraydata1.offProdId == element.products.Id;
                // console.log(finalcoup)
                this.finalcoup = couparraydata1
              });

              // console.log(this.finalcoup)
              // console.log(this.filterProduct)

              if (this.filterProduct.length > 0) {
                if (this.finalcoup.typeId == 2) {
                  // console.log('1111111111111111111111')

                  this.filterProduct.forEach(element => {
                    element.CouponAmt = (element.SubTotal * this.finalcoup.value) / 100
                    this.CouponAmount += element.CouponAmt
                    element.coupTypeid = this.finalcoup.typeId
                    element.coupvalue = this.finalcoup.value
                    element.coupontotal = (element.SubTotal - element.CouponAmt)
                    element.SubTotal = element.coupontotal

                    const coupondata = {
                      couponid: this.selectedCoupon.id,
                      couponamount: element.CouponAmt,
                      coupontypeid: this.finalcoup.typeId,
                      couponcode: this.selectedCoupon.couponCode
                    }

                    element.Coupon = coupondata
                    this.successcoupon = coupondata
                  });


                  this.Livecart.forEach(data => {
                    this.TotalAMount += data.SubTotal
                    this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
                    this.tax = data.products.tax
                    // const Amt = ((this.TotalAMount * data.products.tax) / 100) + this.TotalAMount
                    const Amt = this.TotalAMount

                    this.BillAmount = Math.ceil(Amt);
                  });
                } else {
                  // console.log('2222222222222222222222')
                  this.filterProduct.forEach(element => {
                    element.coupontotal = (element.SubTotal - this.finalcoup.value)
                    element.coupTypeid = this.finalcoup.typeId
                    element.coupvalue = this.finalcoup.value
                    this.CouponAmount = this.finalcoup.value
                    element.SubTotal = element.coupontotal

                    const coupondata = {
                      couponid: this.selectedCoupon.id,
                      couponamount: this.finalcoup.value,
                      coupontypeid: this.finalcoup.typeId,
                      couponcode: this.selectedCoupon.couponCode
                    }
                    element.Coupon = coupondata
                  })


                  this.Livecart.forEach(data => {
                    this.TotalAMount += data.SubTotal
                    this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
                    this.tax = data.products.tax
                    // const Amt = ((this.TotalAMount * data.products.tax) / 100) + this.TotalAMount
                    const Amt = this.TotalAMount

                    this.BillAmount = Math.ceil(Amt);
                  });

                }
              } else {
                // console.log(this.Livecart)
                // console.log(this.finalcoup)


                this.Livecart.forEach(data => {
                  data.CouponAmt = (data.SubTotal * this.finalcoup.value) / 100
                  this.CouponAmount += data.CouponAmt
                  data.coupontotal = (data.SubTotal - data.CouponAmt)
                  data.SubTotal = data.coupontotal
                  this.TotalAMount += data.SubTotal
                  this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
                  this.tax = data.products.tax
                  // const Amt = ((this.TotalAMount * data.products.tax) / 100) + this.TotalAMount
                  const Amt = this.TotalAMount

                  this.BillAmount = Math.ceil(Amt);

                  const coupondata = {
                    couponid: this.selectedCoupon.id,
                    couponamount: data.CouponAmt,
                    coupontypeid: this.finalcoup.typeId,
                    couponcode: this.selectedCoupon.couponCode
                  }

                  data.Coupon = coupondata
                  this.successcoupon = coupondata
                });
              }

              this.HideCoupon = true
              // console.log('1111111111111111111')
            } else {
              this.checkCoupon = true
              this.loadingcoup = false
              // console.log('2222222222222222')

            }
          })
        } else {
          this.checkCoupon = true
          this.loadingcoup = false
          // console.log('3333333333333333')

        }
      }
    } else {
      this.checkCoupon = true
      this.loadingcoup = false
      // console.log('44444444444444444444444444')

    }










  }


  RefCode: string = ''
  checkreferral: boolean = false
  HideReferral: boolean = false
  referraldata: any = []
  successref: any = []
  ReferralAmount: number = 0
  Invalidrefcode: string = ''
  checkprodarr: any = []
  refTypeId: number = 0

  loading: boolean = false;
  applyReferral() {

    if (this.RefCode != '') {
      this.loading = true; // Show loading
    }
    // console.log(this.RefCode);
    // console.log(this.Livecart)
    this.checkprodarr = {
      products: []
    };
    const cusid = localStorage.getItem('customerid');
    if (this.RefCode != '') {
      this.Livecart.forEach(element => {
        const data = {
          prodid: element.products.Id,
          quantity: element.Quantity_No
        };

        this.checkprodarr.products.push(data);
      })
      this.checkprodarr.RefCode = this.RefCode,
        this.checkprodarr.cusid = cusid,

        this.externalService.GetReferralcheck(this.checkprodarr)

      this.externalService._GetReferralcheck.subscribe(response => {
        // console.log(response)



        if (response["isValid"] == true) {
          this.TotalAMount = 0;
          this.ReferralAmount = 0;
          this.tax = 0;
          this.BillAmount = 0;
          this.referraldata = response["referralData"];
          // console.log(this.referraldata)
          this.checkreferral = false;
          this.HideReferral = true;
          this.refTypeId = this.referraldata.type
          if (this.referraldata.type === 1) {
            // console.log('its work type 1');
            if (this.referraldata.type == 1 && this.HideReferral == true) {
              this.payment = 1
            }
            this.Livecart.forEach(data => {
              data.ReferralAmt = (data.SubTotal * this.referraldata.value) / 100;
              this.ReferralAmount += data.ReferralAmt;
              data.referraltotal = data.SubTotal - data.ReferralAmt;
              data.SubTotal = data.referraltotal;
              this.TotalAMount += data.SubTotal;
              this.tax = data.products.tax;
              this.taxAmt = (this.TotalAMount * this.tax) / 100;
              this.BillAmount = Math.ceil(this.TotalAMount);

              data.ref = {
                refid: this.referraldata.id,
                refamount: data.ReferralAmt,
                refcustId: this.finalcoup.customerId,
                refcode: this.referraldata.refCode,
                reftype: this.referraldata.type
              };

              this.successref = data.ref;
            });
          } else {

            if (this.referraldata.type == 2 && this.HideReferral == true) {
              this.payment = 1
            }
            // console.log(this.Livecart);
            // console.log('its work type 2');
            const filterrefproduct = this.Livecart.filter(x => x.ProductId == this.referraldata.productId)
            // console.log(filterrefproduct)
            filterrefproduct.forEach(element => {
              if (element.ProductId === this.referraldata.productId) {
                // console.log(element.ProductId, this.referraldata.productId)
                element.ReferralAmt = (element.SubTotal * this.referraldata.value) / 100;
                this.ReferralAmount += element.ReferralAmt;
                element.referraltotal = element.SubTotal - element.ReferralAmt;
                element.SubTotal = element.referraltotal;

                element.ref = {
                  refid: this.referraldata.id,
                  refamount: element.ReferralAmt,
                  refcustId: this.finalcoup.customerId,
                  refcode: this.referraldata.refCode,
                  reftype: this.referraldata.type
                };

                this.successref = element.ref;
              }
            });

            this.Livecart.forEach(data => {
              this.TotalAMount += data.SubTotal
              this.taxAmt = ((this.TotalAMount * data.products.tax) / 100)
              this.tax = data.products.tax
              // const Amt = ((this.TotalAMount * data.products.tax) / 100) + this.TotalAMount
              const Amt = this.TotalAMount

              this.BillAmount = Math.ceil(Amt);
            });
          }
        } else {
          this.loading = false; // Hide loading after process
          this.checkreferral = true;
          this.Invalidrefcode = response["message"]
        }
      });
    } else {
      this.checkreferral = true;
    }
  }


  deleteCoupon() {
    this.HideCoupon = false
    this.selectedCouponId = 0
    this.loadingcoup = false
    this.Code = ''
    this.successcoupon = []
    this.filterProduct = []
    this.finalcoup = []
    // console.log(this.BackupCart)
    this.selectedCoupon = null
    this.setBillAmount()
  }

  deleteReferral() {
    this.HideReferral = false
    this.loading = false;
    this.RefCode = ''
    this.successref = []
    this.setBillAmount()
  }

  // 21-02-2025

  changecity() {
    const city = this.checkoutForm.controls['city'].value
    // console.log(city)
    if (city == "Madurai") {
      this.maduraiCityError = true
      this.maduraiDeliveryError = true
    } else {
      this.maduraiCityError = false
      this.maduraiDeliveryError = false
    }
  }

  onStateChange(event: any): void {
    const selectedState = event.target.value;
    // console.log('Selected State:', selectedState);

    if (this.citiesByState[selectedState]) {
      this.cities = [...this.citiesByState[selectedState]]; // Update cities array
    } else {
      this.cities = [];
    }

    // console.log('Updated Cities:', this.cities); // Debugging: Check updated cities

    if (this.cities.length > 0) {
      this.checkoutForm.controls.city.enable();
    } else {
      this.checkoutForm.controls.city.disable();
    }

    this.checkoutForm.controls.city.setValue('');
    // Reset city selection
  }

  maduraiDeliveryError: boolean = false;
  maduraiCityError: boolean = false;
  maduraitownError: boolean = false;

  restrictedCityValidator(control: any) {
    const address = control.value;
    if (!address) return null;
    const lowerCaseAddress = address.toLowerCase();
    const lowerCaseRestrictedCities = this.restrictedCities.map(city => city.toLowerCase());

    // Check if any of the restricted cities appear in the address
    const matchFound = lowerCaseRestrictedCities.some(city => lowerCaseAddress.includes(city));

    if (matchFound) {
      this.maduraiCityError = true;
      this.maduraitownError = true;
      return { restrictedCity: true };
    }

    this.maduraiCityError = false;
    this.maduraitownError = false;
    return null;
  }





  cities: string[] = [];
  citiesByState: any = {
    'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Ambattur', 'Avadi', 'Gummidipoondi', 'Kanchipuram', 'Minjur', 'Ponneri',
      'Redhills', 'Sriperumbudur', 'Tindivanam', 'Thiruninravur', 'Thiruthani', 'Thiruvallur', 'Thiruverkadu', 'Tiruvottiyur',
      'Chengalpet', 'Kalpakkam', 'Kandigai', 'Kattupakkam', 'Kelambakkam', 'Kundrathur', 'Mahindra City',
      'Thiruporur', 'Urapakkam', 'Padappai', 'Singaperumal kovil', 'Cuddalore',
      'Coimabatore', 'Madurai'
    ],
    'Andhra Pradesh': ['Tirupati'],
    'Telangana': ['Hyderabad'],
    'Karnataka': ['Bangalore',],
    'Pondicherry': ['Puducherry']
  };

  restrictedCities: string[] = [
    'Alanganallur', 'Melur', 'Usilampatti', 'Vadipatti', 'Elumalai', 'Paravai',
    'Palamedu', 'Sholavandan', 'T.Kallupatti', 'Vellalapatti', 'Madurai-South taluk',
    'Sedapatti', 'Thirumangalam', 'Thiruparankundram', 'Madurai', "Peraiyur", "Mathurai", "madurei", "Maduray", "mathuray"
  ];

  openErrorModal() {
    this.modalService.open(this.errorModal, { centered: true, size: 'lg' });
  }

  // 28-02-2025


  isSpeaking: boolean = false;  // Track if the microphone is active or muted
  speechSynthesis: SpeechSynthesisUtterance;
  voices: SpeechSynthesisVoice[] = [];

  // Load available voices for speech synthesis
  loadVoices() {
    this.voices = speechSynthesis.getVoices();

    // Fallback to a default voice if none are loaded
    if (!this.voices.length) {
      setTimeout(() => this.loadVoices(), 100); // Retry after 100ms if voices are not available yet
    }
  }

  // Function to toggle speech status
  toggleSpeech() {
    if (this.isSpeaking) {
      this.stopSpeaking();  // If already speaking, stop speaking and mute
    } else {
      this.startSpeaking(); // If not speaking, start speaking
    }
  }

  // Start the speaking action
  startSpeaking() {
    this.isSpeaking = true;

    // Create a new SpeechSynthesisUtterance instance
    this.speechSynthesis = new SpeechSynthesisUtterance();

    this.speechSynthesis.text = "Orders can be canceled up to 1 hour before the scheduled delivery time. For customization or enquiry, contact customer support phone number: Nine, zero zero three four three two eight eight eight. To change the order quantity, place a new order or delete the old one and update the quantity in the new order."; // Set full text

    // Ensure voices are loaded before selecting one
    this.voices = speechSynthesis.getVoices();
    this.speechSynthesis.voice = this.voices.find(voice =>
      voice.name.includes('Google UK Female') ||
      voice.name.includes('Google US English') ||
      voice.name.includes('Samantha')
    ) || this.voices[0]; // Fallback voice

    this.speechSynthesis.lang = "en-US";
    this.speechSynthesis.rate = 1.1; // Normal speed

    // Speak the text
    window.speechSynthesis.speak(this.speechSynthesis);
  }

  // Stop the speaking action
  stopSpeaking() {
    this.isSpeaking = false;
    window.speechSynthesis.cancel();  // Stop the speech immediately
  }

  public Termsandcondition(): void {
    // console.log(this.invalidTime,'invalid')
    // console.log(this.time_bool)


    this.timeboolcheck();

    if (this.onlycake == false) {
      this.toastrService.error('Plz Add Cake!');
      return; // Exit the function if condition is met
    }
    // Check if the Delivery Address is selected or added
    if (this.CusAddId == null || this.CusAddId == undefined) {
      this.toastrService.error('Plz Add or Select your Delivery Address');
      return; // Exit the function if condition is met
    }

    // Check if the delivery time is valid
    if (this.time_bool == false) {
      this.toastrService.error('Plz Change Invalid Delivery Date and Time!');
      return; // Exit the function if condition is met
    }

    if (this.invalidTime == true) {
      this.toastrService.error('Plz Change Invalid Delivery Date and Time!');
      return; // Exit the function if condition is met
    }
    // localStorage.setItem('poup', 'true')
    // console.log(this.Livecart)

    this.Qtydata = []; // Make sure it's initialized

    this.Livecart.forEach(ele => {
      if (ele.previousQTY != ele.Quantity_No) {
        const data = {
          id: ele.cartid,
          Qty: ele.Quantity_No
        };
        this.Qtydata.push(data);
      }
    });
    // console.log(this.Qtydata)
    if (this.Qtydata.length > 0) {
      this.externalService.UpdateQty(this.Qtydata);
      this.externalService._getUpdateQty.subscribe(response => {
        //  console.log(response)  
      })
    }


    // If both conditions pass, open the modal
    this.modalService.open(this.Termsmodel, { centered: true, size: 'lg' });
  }

  closepopup() {
    // localStorage.setItem('poup', 'false')
    this.modalService.dismissAll()
  }

  Qtydata: any = []
  public placeOrderNowtest(): void {

    this.timeboolcheck();

    if (this.CusAddId == null || this.CusAddId == undefined) {
      // return alert("Please Add or Select your Delivery Address");
      this.toastrService.error('Please Add or Select your Delivery Address');
    }

    if (this.time_bool == false) {
      // return alert("Please Change Invalid Delivery Date and Time!");
      this.toastrService.error('Please Change Invalid Delivery Date and Time!');


    }
    else {
      // if (this.payment == 1) {
      //   return alert("Temporary Online Service Stopped!");
      // }
      if (this.filteredAddresses.length == 0) {
        // this.toastrService.error('Please fill all required fields', 'Error');
        // return;
      }
      else {
        this.placeord = {}
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        const time = `${hours}:${minutes}:${seconds}`;

        const formattedDate = `${this.deliveryDate.year}-${String(this.deliveryDate.month).padStart(2, '0')}-${String(this.deliveryDate.day).padStart(2, '0')}`;

        const timeString = `${this.timeForm.value.selectedTime.hour.toString().padStart(2, '0')}:${this.timeForm.value.selectedTime.minute.toString().padStart(2, '0')}:00`;


        this.placeord.ta = parseFloat(this.BillAmount.toFixed(2))
        this.placeord.subtotal = this.TotalAMount
        this.placeord.totalItemvalue = this.WoTotalAMount
        this.placeord.tamt = ((this.TotalAMount * this.tax) / 100)
        this.placeord.cui = this.OrdCui
        this.placeord.secid = this.secid;
        this.placeord.cuai = this.CusAddId
        this.placeord.PaymentTypeId = this.payment
        this.placeord.ddT = formattedDate + 'T' + timeString
        this.placeord.N = this.note
        this.placeord.ci = 12
        this.placeord.ino = 'FB-INO'







        // let opt:any=[];
        // this.Livecart.forEach(element=>
        //   {
        //     console.log("element",element)
        //     opt.push([
        //       {
        //       id: element.addons[0]?.id,
        //       name: element.addons[0]?.qtyText,
        //       price: element.addons[0]?.price,
        //       productId: element.addons[0]?.ProductId,
        //       typeId: element.addons[0]?.typeId,
        //       actProdId: element.addons[0]?.actProdId
        //     }
        //   ]) 
        //   this.placeord.items = opt
        //   })


        // this.placeord.items=opt;

        let Items: any = [];
        // console.log(this.Livecart)
        this.Livecart.forEach(element => {
          // Items.push({
          //   product: {
          //     id: element.products.Id,
          //     name: element.products.Name,
          //     quantity: element.Quantity_No,
          //     message: element.Msg,
          //     img: element.products.ImgUrl,

          //     wg_id: element.weight.Id,
          //     wg_qty: element.weight.Qty,
          //     wg_price: element.weight.Price,
          //     wg_qtytxt: element.weight.QtyText,

          //     v_id: element.variants?.id,
          //     v_name: element.variants?.qtyText,
          //     v_price: element.variants?.price,
          //     v_typeId: element.variants?.typeId,
          //     v_actProdId: element.variants?.actProdId

          //   },
          //   weight: {
          //     id: element.weight.Id,
          //     qty: element.weight.Qty,
          //     price: element.weight.Price,
          //     productId: element.ProductId,
          //     typeId: element.weight.TypeId,
          //     qtyText: element.weight.QtyText
          //   },

          //   options: {
          //     addons: [{
          //       id: element.addons[0]?.id,
          //       name: element.addons[0]?.qtyText,
          //       price: element.addons[0]?.price,
          //       productId: element.addons[0]?.ProductId,
          //       typeId: element.addons[0]?.typeId,
          //       actProdId: element.addons[0]?.actProdId
          //     }],



          //     variants: {
          //       id: element.variants?.id,
          //       name: element.variants?.qtyText,
          //       price: element.variants?.price,
          //       productId: element.variants?.ProductId,
          //       typeId: element.variants?.typeId,
          //       actProdId: element.variants?.actProdId
          //     }
          //   }


          // console.log("ele:::",element)
          Items.push({
            product: {
              id: element.products.Id,
              name: element.products.Name,
              quantity: element.Quantity_No,
              message: element.Msg,
              img: element.products.ImgUrl,
              prodtotal: element.ProdTotal,
              catId: element.products.CategoryId,
              wg_id: element.weight.Id,
              wg_qty: element.weight.Qty,
              wg_price: element.weight.Price,
              wg_qtytxt: element.weight.QtyText,

              // this.placeord.tamt = ((this.TotalAMount * this.tax) / 100)

              taxAmt: ((element.ProdTotal * this.tax) / 100),
              to: ((element.ProdTotal * this.tax) / 100) / 2,
              tt: ((element.ProdTotal * this.tax) / 100) / 2,
              v_id: element.variants?.id ? element.variants?.id : null,
              v_name: element.variants?.qtyText ? element.variants?.qtyText : null,
              v_price: element.variants?.price ? element.variants?.price : null,
              v_typeId: element.variants?.typeId ? element.variants?.typeId : null,
              v_actProdId: element.variants?.actProdId ? element.variants?.actProdId : null,
              addons: [{
                id: element.addons[0]?.id,
                name: element.addons[0]?.qtyText,
                price: element.addons[0]?.price,
                productId: element.addons[0]?.ProductId,
                typeId: element.addons[0]?.typeId,
                actProdId: element.addons[0]?.actProdId
              }],
              coupons: element.Coupon || null
            }

          });



          this.placeord.items = Items;
          // console.log(this.successcoupon)
          if (this.successcoupon.couponid > 0) {
            this.placeord.coupenid = this.successcoupon.couponid
            this.placeord.coupenstatus = true
          } else {
            this.placeord.coupenid = 0
            this.placeord.coupenstatus = false
          }

          // console.log(this.successref)
          if (this.successref.refid > 0) {
            this.placeord.RefId = this.successref.refid
            this.placeord.Refstatus = true
            this.placeord.RefType = this.successref.reftype
          } else {
            this.placeord.RefId = 0
            this.placeord.Refstatus = false
            this.placeord.RefType = 0
          }

        })

        // console.log("PLace Orders::::", this.placeord);
        this.modalService.dismissAll()
        document.getElementById('preloaderco').style.display = 'block'
        this.productService.SaveOrder(this.placeord).subscribe(response => {
          if (response && response['status'] == 200) {
            // localStorage.setItem('poup', 'false')
            this.OrdId = response.oid
            // console.log(this.OrdId)
            localStorage.setItem("myApp_CartCount", '0');
            this.myService.cartsource.next(0)
            document.getElementById('preloaderco').style.display = 'none'
            this.modalService.open(this.Orddetail, { centered: true, size: 'lg' });
          } else {
            // localStorage.setItem('poup', 'false')
            this.toastrService.error('Order', 'Order Placed UnSuccessfully !..')
          }
        });
      }
    }
  }


  autoResize(event: any) {
    const textarea = event.target;
    textarea.style.height = "50px"; // Reset to initial height
    textarea.style.height = textarea.scrollHeight + "px"; // Set to new height
  }




  Payloadonline() {
    // console.log("PLace Orders::::", this.placeord);
  }



  // submitest() {
  //   if (this.Livecart.forEach(ele => ele.previousQTY != ele.Quantity_No)) {
  //     console.log('work', this.Livecart)
  //   }
  // }



}


